<template>
  <a-table class="table" :columns="columns" :dataSource="data" :pagination="false" bordered> </a-table>
</template>
<script>
export default {
  data () {
    return {
      columns: [
        {
          title: '状态',
          dataIndex: 'anln1',
          align: 'center',
          width: 100
        },
        {
          title: '折旧月份',
          dataIndex: 'afabe',
          align: 'center',
          width: 100
        },
        {
          title: '正常折旧TBP',
          dataIndex: 'afasl',
          align: 'center',
          width: 100
        },
        {
          title: '计划外折旧TBP',
          dataIndex: 'ndjar',
          align: 'center',
          width: 100
        },
        {
          title: '储备金',
          dataIndex: 'ndper',
          align: 'center',
          width: 100
        },
        {
          title: '重估',
          dataIndex: 'xloev',
          align: 'center',
          width: 100
        },
        {
          title: '货币',
          dataIndex: 'currency',
          align: 'center',
          width: 100
        }
      ],
      data: [
        {
          id: '1',
          anln1: '已过账',
          afabe: '1',
          afasl: '6,497.64-',
          ndjar: '0.00',
          ndper: '0.00',
          xloev: '0.00',
          currency: 'CNY'
        },
        {
          id: '2',
          anln1: '已过账',
          afabe: '2',
          afasl: '6,497.64-',
          ndjar: '0.00',
          ndper: '0.00',
          xloev: '0.00',
          currency: 'CNY'
        },
        {
          id: '3',
          anln1: '已过账',
          afabe: '3',
          afasl: '6,497.64-',
          ndjar: '0.00',
          ndper: '0.00',
          xloev: '0.00',
          currency: 'CNY'
        },
        {
          id: '4',
          anln1: '已过账',
          afabe: '4',
          afasl: '6,497.64-',
          ndjar: '0.00',
          ndper: '0.00',
          xloev: '0.00',
          currency: 'CNY'
        },
        {
          id: '5',
          anln1: '已过账',
          afabe: '5',
          afasl: '6,497.64-',
          ndjar: '0.00',
          ndper: '0.00',
          xloev: '0.00',
          currency: 'CNY'
        },
      ],
    }
  },
  methods: {}
}
</script>

<style lang="less" scoped>
.table /deep/ .ant-table-thead > tr > th {
  padding: 10px !important;
}
.table /deep/ .ant-table-tbody > tr > td {
  padding: 10px;
}
</style>
